import { ComboBetType } from '@/feature/betslip-sbk/types';
import { getComboBetTypeFromGroupedSelections } from '@/feature/betslip-sbk/utils/betslip-utils';

import { Bet } from '../hooks/types';

export type SbkBetVariant = 'SINGLE' | ComboBetType; // 'SINGLE' | 'PARLAY' | 'SGP' | 'SGP+'

/**
 * Classifies a settled or open bet into its display variant. Combos are split into Parlay / SGP /
 * SGP+ by reusing the betslip classifier on the per-event selection counts.
 */
export const classifyBetVariant = (bet: Bet): SbkBetVariant => {
    if (bet.bet_type === 'SINGLE') {
        return 'SINGLE';
    }
    return getComboBetTypeFromGroupedSelections(bet.events.map(event => event.selections.length));
};
